import React from "react"; // eslint-disable-line no-unused-vars
import { Rocket, Cloud, Code, Package, Zap, Shield, BarChart3, Container, Lock } from "lucide-react";
import Card from "./Card";

function Service() {
  const services = [
    {
      title: "DevOps Consulting",
      icon: <Rocket size={28} />,
      text: "End-to-end DevOps transformation with modern CI/CD pipelines, automated testing, and continuous deployment strategies that accelerate your software delivery."
    },
    {
      title: "Cloud Architecture",
      icon: <Cloud size={28} />,
      text: "Design and implement scalable, secure cloud infrastructure on AWS, Azure, or GCP. Strategic cloud migration planning with cost optimization and best practices."
    },
    {
      title: "Python Development",
      icon: <Code size={28} />,
      text: "Full-stack Python development including microservices, RESTful APIs, data pipelines, and cloud-native applications with modern frameworks like Django and FastAPI."
    },
    {
      title: "AWS Migrations",
      icon: <Package size={28} />,
      text: "Seamless legacy infrastructure migration to AWS cloud with zero downtime. Expertise in rehosting, replatforming, refactoring, and re-architecting workloads."
    },
    {
      title: "Kafka & Event Streaming",
      icon: <Zap size={28} />,
      text: "Build real-time data streaming platforms with Apache Kafka. Design event-driven architectures for high-throughput, fault-tolerant data processing at scale."
    },
    {
      title: "Site Reliability Engineering",
      icon: <Shield size={28} />,
      text: "Implement SRE best practices with comprehensive monitoring, alerting, and incident response. Ensure 99.9% uptime with proactive performance optimization."
    },
    {
      title: "Infrastructure as Code",
      icon: <BarChart3 size={28} />,
      text: "Automate infrastructure provisioning with Terraform, CloudFormation, or Ansible. Version-controlled, repeatable infrastructure deployments across environments."
    },
    {
      title: "Container Orchestration",
      icon: <Container size={28} />,
      text: "Deploy and manage containerized applications with Kubernetes and Docker. Build self-healing, auto-scaling container platforms for modern microservices."
    },
    {
      title: "Security & Compliance",
      icon: <Lock size={28} />,
      text: "Implement DevSecOps practices with automated security scanning, compliance monitoring, and vulnerability management integrated into your CI/CD pipeline."
    }
  ];

  return (
    <section id="services" className="services-section page-section">
      <div className="section-divider"><div></div></div>
      <div className="container py-5">
        <div className="text-center mb-5">
          <div className="section-badge">Our Expertise</div>
          <h2 className="modern-title">
            Enterprise-Grade <span className="gradient-text">DevOps Services</span>
          </h2>
          <p className="lead modern-subtitle">
            Comprehensive solutions for your digital transformation journey
          </p>
        </div>

        <div className="row g-4">
          {services.map((service, index) => (
            <Card
              key={index}
              title={service.title}
              icon={service.icon}
              text={service.text}
            />
          ))}
        </div>

        <div className="cta-section mt-5 pt-5">
          <div className="modern-card cta-card text-center p-5">
            <h2 className="mb-4">Ready to Transform Your Infrastructure?</h2>
            <p className="lead mb-4">Let's discuss how we can accelerate your DevOps journey</p>
            <a href="#contact" className="btn modern-btn btn-lg">
              Schedule a Consultation &rarr;
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Service;
